import { Button } from '@/components/ui/button';
import { formatDate } from '@/lib/format';
import { inc as metricsInc } from '@/lib/metrics';

export default function CreditGateBanner({ cost, resetAt, cancelAtPeriodEnd, onManage, place }: { cost: number; resetAt?: string; cancelAtPeriodEnd?: boolean; onManage: () => void; place?: 'chat'|'editor'; }) {
  const dateText = formatDate(resetAt || null);
  const offline = typeof navigator !== 'undefined' && navigator.onLine === false;
  const text = `Out of credits to make new plots. Credits reset on ${dateText}.`;
  return (
    <div className="sticky bottom-0 inset-x-0 p-3">
      <div
        role="status"
        className="rounded-xl bg-primary/10 border border-primary/20 p-4 flex items-center justify-between gap-3"
        data-cost={cost}
      >
        <div className="text-sm text-foreground/90">
          <span>{text}</span>
          {offline && <span className="ml-2 text-muted-foreground">Check your connection if this seems wrong.</span>}
        </div>
        <Button onClick={() => { try { metricsInc('credits_upgrade_click', { place, source: 'banner', tier: 'unknown' }); } catch {} onManage(); }} aria-label={cancelAtPeriodEnd ? 'Manage' : 'View plans'}>
          {cancelAtPeriodEnd ? 'Manage' : 'View plans'}
        </Button>
      </div>
    </div>
  );
}


